import React, { ComponentProps } from "react";

export enum ArrowRightIconVariants {
  THIN,
  THICK,
}

interface ArrowRightIconProps extends ComponentProps<"svg"> {
  variant?: ArrowRightIconVariants;
}

function ArrowRightIcon({ variant, ...props }: ArrowRightIconProps) {
  if (variant === ArrowRightIconVariants.THIN) {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={7}
        height={12}
        viewBox="0 0 7 12"
        fill="none"
        {...props}
      >
        <path
          d="M1.16602 1.33342L5.83268 6.00008L1.16602 10.6667"
          stroke={props.stroke ?? "#6C53E8"}
          strokeWidth="0.8"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={7}
      height={12}
      viewBox="0 0 7 12"
      {...props}
    >
      <path d="M1.70528 11.2766C1.94403 11.2766 2.18403 11.1853 2.36653 11.0028L6.72528 6.66533C6.90153 6.48908 7.00028 6.25033 7.00028 6.00033C7.00028 5.75158 6.90153 5.51283 6.72528 5.33658L2.36653 0.996583C2.00028 0.631583 1.40778 0.631583 1.04153 0.999083C0.676525 1.36658 0.677775 1.96033 1.04403 2.32533L4.73528 6.00033L1.04403 9.67533C0.677775 10.0403 0.676525 10.6328 1.04153 11.0003C1.22403 11.1853 1.46528 11.2766 1.70528 11.2766Z" />
    </svg>
  );
}

export default ArrowRightIcon;
